import React, {Component} from 'react';
import {action, observable} from 'mobx';
import {inject, observer} from 'mobx-react';

import './style.scss'
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import moment from "moment/moment";
import ModalLoading from "../../../components/common/ModalLoading";
import NotificationSendModal from "./NotificationSendModal";
import MailTemplateModal from "./MailTemplateModal";
import SmsTemplateModal from "./SmsTemplateModal";
import {
  Badge,
  Button, ButtonGroup,
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
  FormCheckbox,
  FormInput,
  FormSelect,
  InputGroup,
  InputGroupAddon,
  Modal,
  ModalBody,
  ModalHeader
} from "shards-react";
import {toast} from "react-toastify";
import {reactLocalStorage as Storage} from "reactjs-localstorage";


@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ company }) => ({ updateShop: company.updateShop }))

@inject(({ AOA }) => ({ getShopList:AOA.getShopList, getStoreList:AOA.getStoreList, getStoreDetail:AOA.getStoreDetail, updateStoreMemo:AOA.updateStoreMemo, csLogin:AOA.csLogin,
  renewToken:AOA.renewToken, unsubscribeUser: AOA.unsubscribeUser, withdrawal: AOA.withdrawal, adminCusData:AOA.adminCusData, sendMailTo:AOA.sendMailTo, getAutomaticPayments:AOA.getAutomaticPayments, setShopReviewWriteAddon: AOA.setShopReviewWriteAddon }))
@inject(({ review }) => ({ removeReviewMany: review.removeReviewMany, adminReviewImgDomainUpdate:review.adminReviewImgDomainUpdate, genThumbImg:review.genThumbImg }))
@inject(({ product }) => ({ latestOderUpdate: product.latestOderUpdate, getOrderFormPlatform: product.getOrderFormPlatform, adminProductImgDomainUpdate:product.adminProductImgDomainUpdate }))


@observer
class ShopList extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable isBatchSyncing = false;
  @observable batchSyncProgress = '';

  @observable storageCfg = {
    is: true,
    etcType: "fn"
  };

  //list
  @observable listParams = {
    page:1, limit:100,
    displayStatus: 100,
    searchParams: {
      displayAt: 'all',
      isPaidUser: true,
    }
  }
  @observable list = {};
  @observable searchFormValue = {
    isPaidUser: true,
    isUseFirstOrder: false,
    isFreeStore: false,
    isActiveSkin: false
  }

  @observable ssTotalPrice = 0;
  @observable inAppOrderLength = 0;

  // 기능 컬럼 알림 드롭다운 (row 별 open 상태)
  @observable notifyDropdowns = {};


  //modals
  @observable modals = {
    isStoreDetail: false,
    storeDetailData: {},
    isImgDomainConfirm: false,
    imgDomainConfirmData: null,
  };
  @observable isImgDomainRunning = false;

  @observable toggledShops = {};
  @observable toggledOrders = {};

  // 프론트단 주문일(day) 정렬 상태: null, 'asc', 'desc'
  @observable orderDaySort = null;
  @observable payDaySort = null;
  @observable orderCountSort = null;

  //dropDowns
  @observable dropDowns = {};

  constructor(props) {
    super(props);
    this.init()

    this.onChangeValue = this.onChangeValue.bind(this);


  }

  componentDidUpdate(prevProps, prevState){

  }

  @action
  init = async (key) => {

    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.teamUser.email = this.teamUser.email ? this.teamUser.email : this.teamUser.emailId;
      this.store = this.props.me.store;
      this.listParams.store_id = this.store._id;

      let storageCfg = await Storage.getObject('storageCfg');
      if(storageCfg.is) {
        this.storageCfg = storageCfg;
      }

      // URL 쿼리스트링의 keyword (예: /shopList?keyword=mallid) 가 있으면 전체 스토어 탭에서 자동 검색
      const urlKeyword = (() => {
        try { return new URLSearchParams(window.location.search).get('keyword') || ''; }
        catch(e) { return ''; }
      })();

      // localStorage에서 저장된 탭 정보 복원
      // isAll(전체 스토어) 탭은 검색 결과 전용 — 첫 접근시 복원하지 않고 유료샵 기본 화면으로 노출
      const savedTab = Storage.get('shopList_selectedTab');
      if (urlKeyword) {
        // 검색 모드 — isAll 탭으로 진입 + keyword 설정
        this.searchFormValue.automaticPayment = false;
        this.searchFormValue.onepay = false;
        this.searchFormValue.isAll = true;
        this.searchFormValue.isFreeStore = false;
        this.searchFormValue.isSuspended = false;
        this.searchFormValue.isActiveSkin = false;
        this.listParams.searchParams.automaticPayment = false;
        this.listParams.searchParams.onepay = false;
        this.listParams.searchParams.isAll = true;
        this.listParams.searchParams.isFreeStore = false;
        this.listParams.searchParams.isSuspended = false;
        this.listParams.searchParams.isActiveSkin = false;
        this.listParams.searchParams.keyword = urlKeyword.trim();
      } else if(savedTab && savedTab !== 'isAll') {
        this.restoreTabFromStorage(savedTab);
      } else if (savedTab === 'isAll') {
        Storage.remove('shopList_selectedTab');
      }

      this.permissions = this.props.me.permissions;

      // 리스트 조회
      this.getList();
    }
    else {

      if(Storage.get('token')) {
        //todo 재확인 - 로그인 후 해당 페이지로 넘어 오는 경우 authCheck() 함수 미샐행 할 수 있게.
        //this.props.authCheck();
      }
      // else {
      //   window.location.replace('signIn');
      // }

    }
  };

  @action
  restoreTabFromStorage = (tabName) => {
    // 모든 필터 초기화
    this.searchFormValue.automaticPayment = false;
    this.searchFormValue.onepay = false;
    this.searchFormValue.isAll = false;
    this.searchFormValue.isFreeStore = false;
    this.searchFormValue.isSuspended = false;
    this.searchFormValue.isActiveSkin = false;

    // 저장된 탭에 따라 필터 설정
    this.searchFormValue[tabName] = true;

    // searchParams 동기화
    this.listParams.searchParams.automaticPayment = false;
    this.listParams.searchParams.onepay = false;
    this.listParams.searchParams.isAll = false;
    this.listParams.searchParams.isFreeStore = false;
    this.listParams.searchParams.isSuspended = false;
    this.listParams.searchParams.isActiveSkin = false;

    if (tabName === 'isSuspended') {
      this.listParams.searchParams.isPaidUser = false;
    }

    // 선결제 샵은 사용완료순 기본 정렬
    if (tabName === 'onepay') {
      this.listParams.sort = 'useExpiryDate';
    }

    this.listParams.searchParams[tabName] = true;
  };

  @action
  getList = async() => {
    Storage.set('limitStoreList', this.listParams.limit);
    // 리스트 조회 시 프론트단 정렬 상태 초기화
    this.orderDaySort = null;
    this.payDaySort = null;
    this.orderCountSort = null;
    if(this.listParams.store_id) {
      this.list = await this.props.getShopList(this.listParams);
      // 샘플샵 안전망 — 백엔드 storeQuery 가 누락된 케이스 대비
      if (this.list && Array.isArray(this.list.docs)) {
        const before = this.list.docs.length;
        this.list.docs = this.list.docs.filter(d => {
          const store = d && (d.store_id || d);
          return !(store && store.isSample === true);
        });
        const removed = before - this.list.docs.length;
        if (removed > 0 && typeof this.list.totalDocs === 'number') {
          this.list.totalDocs = Math.max(0, this.list.totalDocs - removed);
        }
      }
      console.log(this.list)
      this.isLoading = false;
    }
    else {
      this.isLoading = false;
    }


  };

  urlParamsToListParams = function() {

    let searchFormValueArr = {};
    for (const key of this.urlParams.keys()) {

      if(['page'].indexOf(key) > -1 || ['limit'].indexOf(key) > -1) {
        this.listParams[key] = parseInt(this.urlParams.get(key));
      }
      else {
        if(key.indexOf('__') > -1) {
          let keyArr = key.split('__');
          if(!searchFormValueArr[keyArr[0]]) { searchFormValueArr[keyArr[0]] = {};}
          searchFormValueArr[keyArr[0]][keyArr[1]] = true;
        }
        else {
          if(this.urlParams.get(key) === "true") {
            this.searchFormValue[key] = true;
            this.listParams.searchParams[key] = true;
          }
          else if(this.urlParams.get(key) === "false") {
            this.searchFormValue[key] =  false;
            this.listParams.searchParams[key] = false;
          }
          else {
            this.searchFormValue[key] = this.urlParams.get(key);
            this.listParams.searchParams[key] = this.urlParams.get(key);
          }

        }
      }
    }

    for(let key in searchFormValueArr) {
      if(searchFormValueArr[key].all) {
        for(let deKey in this.searchFormValue[key]) {
          this.searchFormValue[key][deKey] = true;
        }
      }
      else {
        for(let deKey in this.searchFormValue[key]) {
          if(searchFormValueArr[key][deKey]) {
            this.searchFormValue[key][deKey] = true;
          }
          else {
            this.searchFormValue[key][deKey] = false;
          }
        }
      }
      this.listParams.searchParams[key] = searchFormValueArr[key];
    }


    this.getList();
  }

  onChangeValue = async (event) => {
    const { name, value } = event.target;
    if(name === 'password') {
      this.teamUser[name] = value;
    }
    else {
      this.teamUser[name] = value;
    }
  };

  @observable notifyModal = { isOpen: false, params: null };
  @observable mailTplOpen = false;
  @observable smsTplOpen = false;

  openNotifyModal = (item, type, prevPlan) => {
    this.notifyModal = { isOpen: true, params: { item, type, prevPlan } };
  };

  closeNotifyModal = () => {
    this.notifyModal = { isOpen: false, params: null };
  };

  // 기능 컬럼 알림 드롭다운 토글 (row 별)
  notifyDropdownToggle = (key) => {
    this.notifyDropdowns[key] = !this.notifyDropdowns[key];
  };

  openMailTpl = () => { this.mailTplOpen = true; };
  closeMailTpl = () => { this.mailTplOpen = false; };
  openSmsTpl = () => { this.smsTplOpen = true; };
  closeSmsTpl = () => { this.smsTplOpen = false; };

  sendMailTo = async (item, type, prevPlan) => {
    let params = {
      id: item.store_id._id,
      shopNo: item.platformShopNo,
      type: type
    }
    if (prevPlan) {
      params.prevPlan = prevPlan;
    }
    this.isLoading = true;

    const res = await this.props.sendMailTo(params);
    if (res.errors && res.errors.length > 0) {
      toast.error(res.errors[0].message);
      this.isLoading = false;
    } else {
      toast.success('메일이 성공적으로 전송되었습니다.');
      this.isLoading = false;
    }
  };

  csLogin = async (item) => {
    // 전체 스토어 탭에서는 item이 직접 store 데이터, 다른 탭에서는 item.store_id가 store 객체
    const store = item.store_id ? item.store_id : item;
    let params = {
      id: store._id,
      platformId: store.platformId,
      emailId: store.email
    }
    console.log(params)
    await this.props.csLogin(params);
    await Storage.remove("shops");
    window.location.href = "/reviewList";
  };

  renewToken = async (item) => {
    if(window.confirm('모든 주문 사용자의 토큰을 갱신 처리 하시겠습니까?')) {
      let params = {
        store_id: this.store._id,
      }
      await this.props.renewToken(params);
    }
  }

  delAllReview = async function(item) {
    if(window.confirm('모든 리뷰를 삭체 처리 하시겠습니까?')) {
      let withDrawStore = {
        store_id: item.store_id._id,
        // startDate: moment().subtract(3, 'years'),
        // endDate: moment().subtract(1, 'months')
      };
      await this.props.removeReviewMany(withDrawStore);
    }
  };

  withdrawal = async (item) => {
    if(window.confirm('탈퇴처리 하시겠습니까?')) {
      let withDrawStore = {
        store_id: item.store_id,
        reason: "탈퇴처리"
      };
      await this.props.withdrawal(withDrawStore);
    }

  };

  unsubscribeUser = async (item) => {
    if(!item.shopNo) {
      alert("구독취소할 멀티샵을 선택해 주세요.");
      return false;
    }
    if(window.confirm('구독취소 하시겠습니까?')) {
      let unsubscribeUser = {
        store_id: item._id,
        shopNo: parseInt(item.shopNo)
      };
      await this.props.unsubscribeUser(unsubscribeUser);
    }

  };

  updateStoreMemo = async (item) => {
    let params = {
      id: item._id,
      memo: item.memo
    }
    await this.props.updateStoreMemo(params);
  };

  onChangeMemoValue = async (event, item) => {
    const { name, value } = event.target;
    item[name] = value;
  };

  // 이번달 결제 여부 업데이트
  updateShopPaymentStatus = async (item, isPaymentThisMonth) => {
    let params = {
      id: item._id,
      isPaymentThisMonth: isPaymentThisMonth
    }
    this.props.updateShop(params, (res) => {
      if(res.errors && res.errors.length > 0) {
        toast.error(res.errors[0].message);
      } else {
        // 리스트 아이템 업데이트
        item.isPaymentThisMonth = isPaymentThisMonth;
        toast.success(isPaymentThisMonth ? '결제 완료로 변경되었습니다.' : '미결제로 변경되었습니다.');
      }
    });
  };

  // 이번 달 구독 결제 여부 판단 (리스트용 - item.orderUpdatedAt 사용)
  // 구독(automaticPayment === 'T') 인 경우에만 판단, 선결제(F) 는 항상 false
  isThisMonthPaidFromOrder = (inAppOrder, orderUpdatedAt) => {
    if (!inAppOrder || !orderUpdatedAt) return false;
    if (inAppOrder.automaticPayment !== "T") return false;
    // 시간은 보지 않고 년-월까지만 비교
    return moment(orderUpdatedAt).format('YYYY-MM') === moment().format('YYYY-MM');
  };

  // 이번달 결제 컬럼 헤더 (최근 결제일 바로 오른쪽에 렌더)
  renderThisMonthPayTh = () => {
    if(!this.searchFormValue.automaticPayment) return null;
    return (
      <th style={{textAlign: 'center'}}>
        이번달 결제
        <Button
          size="sm"
          theme="light"
          style={{marginLeft: '5px', padding: '2px 5px'}}
          title="자동결제 데이터 동기화"
          onClick={() => this.resetAllPaymentStatus()}
        >
          <FeatherIcon icon="refresh-cw" size="12"/>
        </Button>
      </th>
    );
  };

  // 이번달 결제 컬럼 셀 (최근 결제일 바로 오른쪽에 렌더)
  renderThisMonthPayTd = (item) => {
    if(!this.searchFormValue.automaticPayment) return null;
    return (
      <td style={{textAlign: 'right'}}>
        {(() => {
          const getPayDate = (p) => p.pay_date || p.payment_date || p.paid_date || p.approval_date || p.order_date || p.created_date || '';
          // 구독(automatic_payment === 'T') 결제만 대상 — 선결제는 제외
          const subPayments = (item.lastPaymentData || []).filter(p =>
            p.automatic_payment === 'T' && p.payment_status === 'paid' && getPayDate(p)
          );
          const lastPay = subPayments.length > 0
            ? subPayments.reduce((latest, p) => {
                const d = getPayDate(p);
                const ld = getPayDate(latest);
                return d > ld ? p : latest;
              }, subPayments[0])
            : null;
          const lastPayDate = lastPay ? getPayDate(lastPay) : '';
          const nextPayDate = lastPayDate ? moment(lastPayDate).add(30, 'days') : null;
          const isPaid = !!(item.isPaymentThisMonth !== undefined ? item.isPaymentThisMonth : this.isThisMonthPaidFromOrder(item.inAppOrder_id, item.orderUpdatedAt));
          const isOverdue = nextPayDate && nextPayDate.isBefore(moment());
          return (
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '6px', fontSize: '11px'}}>
              {nextPayDate ? (
                <span style={{color: isOverdue ? '#e53e3e' : '#718096', whiteSpace: 'nowrap'}}>
                  {nextPayDate.format('MM.DD')} ({isOverdue ? '경과' : 'D-' + nextPayDate.diff(moment(), 'days')})
                </span>
              ) : null}
              <span
                onClick={() => {
                  const currentStatus = item.isPaymentThisMonth !== undefined ? item.isPaymentThisMonth : this.isThisMonthPaidFromOrder(item.inAppOrder_id, item.orderUpdatedAt);
                  this.updateShopPaymentStatus(item, !currentStatus);
                }}
                style={{
                  display: 'inline-block', padding: '3px 10px', borderRadius: '12px', cursor: 'pointer',
                  fontSize: '10px', fontWeight: '700', whiteSpace: 'nowrap',
                  background: isPaid ? '#c6f6d5' : '#fed7d7',
                  color: isPaid ? '#276749' : '#9b2c2c'
                }}
              >
                {isPaid ? '결제' : '미결제'}
              </span>
            </div>
          );
        })()}
      </td>
    );
  };

  // 이번달 결제 여부 동기화 (getAutomaticPayments API 기반)
  resetAllPaymentStatus = async () => {
    if(!window.confirm('이번달 자동결제 데이터를 기반으로 결제 여부를 동기화하시겠습니까?')) {
      return;
    }

    this.isLoading = true;
    toast.info('결제 데이터를 조회 중입니다...');

    try {
      const paymentData = await this.props.getAutomaticPayments();
      console.log(paymentData);

      if(!paymentData || !paymentData.data) {
        toast.error('결제 데이터를 조회할 수 없습니다.');
        this.isLoading = false;
        return;
      }

      // 이번 달(YYYY-MM) 기준 — 시간 무시, 일까지만 비교
      const currentYM = moment().format('YYYY-MM');

      // 이번 달에 구독(automatic_payment === 'T') 결제 완료된 store_id 목록 생성
      // 선결제(automatic_payment === 'F')는 대상에서 제외
      const paidStoreIds = new Set();
      paymentData.data.forEach(store => {
        if(store.payments && store.payments.payments && store.payments.payments.length > 0) {
          const hasThisMonthPayment = store.payments.payments.some(payment => {
            if (payment.payment_status === 'paid'
                && payment.automatic_payment === 'T'
                && payment.pay_date) {
              return moment(payment.pay_date).format('YYYY-MM') === currentYM;
            }
            return false;
          });

          if(hasThisMonthPayment) {
            paidStoreIds.add(store.store_id);
          }
        }
      });

      console.log('이번달 결제 완료 store:', paidStoreIds.size, '개');

      let successCount = 0;
      let errorCount = 0;

      const docs = this.list.docs || [];
      for(let item of docs) {
        // store_id로 매칭 (item.store_id._id 또는 item.store_id)
        const storeId = item.store_id && item.store_id._id ? item.store_id._id : (item.store_id || item._id);
        const shouldBePaid = paidStoreIds.has(storeId);
        const currentStatus = item.isPaymentThisMonth || false;

        // 현재 상태와 다른 경우에만 업데이트
        if(shouldBePaid !== currentStatus) {
          let params = {
            id: item._id,
            isPaymentThisMonth: shouldBePaid
          };
          /* eslint-disable no-loop-func */
          await new Promise((resolve) => {
            this.props.updateShop(params, (res) => {
              if(res.errors && res.errors.length > 0) {
                errorCount++;
              } else {
                item.isPaymentThisMonth = shouldBePaid;
                successCount++;
              }
              resolve();
            });
          });
          /* eslint-enable no-loop-func */
        }
      }

      this.isLoading = false;
      if(errorCount > 0) {
        toast.warning(`${successCount}개 동기화 완료, ${errorCount}개 실패`);
      } else {
        toast.success(`${successCount}개 결제 상태가 동기화되었습니다. (이번달 결제완료: ${paidStoreIds.size}개)`);
      }
    } catch(error) {
      console.error(error);
      toast.error('결제 데이터 동기화 중 오류가 발생했습니다.');
      this.isLoading = false;
    }
  };

  onChangeSearchValue = async (event, obj) => {
    const { name, value, type } = event.target;
    let newValue;
    if(type === 'checkbox') {
      if(value) {
        newValue = !JSON.parse(value);
      }
      else {
        newValue = true;
      }
    }
    else {
      newValue = value;
    }

    if(obj) {
      obj[name] = newValue;

      if(name === 'all') {
        for(let key in obj) {
          obj[key] = newValue;
        }
      }
      else {
        let isAll = false;
        if(newValue) {
          isAll = true;
          for(let key in obj) {
            if(!obj[key] && key !== 'all') {
              isAll = false;
              break;
            }
          }
        }
        obj['all'] = isAll;
      }
    }
    else {
      this.searchFormValue[name] = newValue;
      if(name === 'isDelete') {
        for(let key in this.searchFormValue.reviewDis) {
          this.searchFormValue.reviewDis[key] = !newValue;
        }
      }
    }

    if(name === "sort") {
      this.listParams.sort = newValue;
      this.getList();
    }
  };

  onChangeStorageCfg = async (targetObj, val, key) => {
    console.log(targetObj)
    if(key) {
      targetObj[key] = val;
    }
    else {
      targetObj = val;
    }
    Storage.setObject('storageCfg', this.storageCfg);
  };

  updateStoreMemo = async (item) => {
    let params = {
      id: item._id,
      memo: item.memo
    }
    await this.props.updateStoreMemo(params);
  };

  onChangeMemoValue = async (event, item) => {
    const { name, value } = event.target;
    item[name] = value;
  };

  modalToggle = function(target, data) {
    let _this = this;
    if(!target) {
      for( var i in _this.modals) {
        if(i.indexOf('is') === 0) {
          _this.modals[i] = false;
        }
      }
    }
    else {
      _this.modals[target] = !this.modals[target];
    }

    if(data) {
      if(target === 'isStoreDetail' && data) {
        // 전체 스토어 탭에서는 data가 직접 store 데이터, 다른 탭에서는 data.store_id가 store 객체
        const isAllTab = !data.store_id;

        if (isAllTab) {
          // 전체 스토어 탭: data를 store_id로 래핑
          _this.modals.storeDetailData = {
            ...data,
            store_id: data,
            inAppOrder_id: data.lastInAppOrder_id
          };
        } else {
          _this.modals.storeDetailData = data;
        }

        const store_id = isAllTab ? data._id : data.store_id._id;
        const order_id = isAllTab ? (data.lastInAppOrder_id ? data.lastInAppOrder_id._id : null) : (data.inAppOrder_id ? data.inAppOrder_id._id : null);
        const shopNo = isAllTab ? (data.shopNo || 1) : (data.platformShopNo || 1);

        let params = {
          store_id: store_id,
          order_id: order_id,
          shopNo: shopNo,
          isRefreshToken: true
        }
        this.props.getStoreDetail(params, function(res) {
          if(res.errors && res.errors.length > 0) {
            toast(res.errors[0].message);
          }
          else {
            _this.modals.storeDetailData.detail = res.data;
            console.log(_this.modals.storeDetailData)
            _this.modals.shop= res.data.shop;
          }
        });

      }
      else {
        _this.modals.data = data;
      }

    }
  };

  // 리뷰 부스터 권한(reviewWriteAddon) 개별 토글 — shopList 상세 모달
  setShopReviewWriteAddonRunning = false;
  toggleShopReviewWriteAddon = (nextValue) => {
    const d = this.modals.storeDetailData || {};
    const storeId = (d.store_id && d.store_id._id) ? d.store_id._id : (typeof d.store_id === 'string' ? d.store_id : d._id);
    const shopNo = d.platformShopNo || d.shopNo || 1;
    if (!storeId) { toast.error('스토어 정보를 찾을 수 없습니다.'); return; }
    if (this.setShopReviewWriteAddonRunning) return;
    this.setShopReviewWriteAddonRunning = true;
    let _this = this;
    this.props.setShopReviewWriteAddon({ store_id: storeId, shopNo: shopNo, isActive: !!nextValue }, function(res, errors) {
      _this.setShopReviewWriteAddonRunning = false;
      if (errors && errors.length > 0) { toast.error(errors[0].message || '권한 변경 실패'); return; }
      const okData = res && res.data;
      if (!okData || !okData.ok) { toast.error((okData && okData.error) || '권한 변경 실패'); return; }
      const newVal = !!okData.reviewWriteAddon;
      if (!_this.modals.storeDetailData.entitlements) _this.modals.storeDetailData.entitlements = {};
      _this.modals.storeDetailData.entitlements.reviewWriteAddon = newVal;
      if (_this.modals.shop) {
        if (!_this.modals.shop.entitlements) _this.modals.shop.entitlements = {};
        _this.modals.shop.entitlements.reviewWriteAddon = newVal;
      }
      toast.success('리뷰 부스터 권한이 ' + (newVal ? '부여' : '회수') + '되었습니다.');
    });
  };

  @action
  batchSyncStoreDetails = async () => {
    if (this.isBatchSyncing) return;
    if (!this.list || !this.list.docs || this.list.docs.length === 0) {
      toast('동기화할 샵이 없습니다.');
      return;
    }

    const docs = this.list.docs.filter(item => item.store_id);
    const total = docs.length;
    this.isBatchSyncing = true;
    this.batchSyncProgress = '0/' + total;
    let completed = 0;

    for (let i = 0; i < docs.length; i++) {
      const item = docs[i];
      const store_id = item.store_id._id;
      const order_id = item.inAppOrder_id ? item.inAppOrder_id._id : null;
      const shopNo = item.platformShopNo || 1;

      try {
        await new Promise((resolve) => {
          this.props.getStoreDetail({
            store_id: store_id,
            order_id: order_id,
            shopNo: shopNo,
            isRefreshToken: true
          }, function(res) {
            resolve(res);
          });
        });
      } catch(e) {
        console.log('sync error:', item.store_id.name, e);
      }

      completed++;
      this.batchSyncProgress = completed + '/' + total;
    }

    this.isBatchSyncing = false;
    this.batchSyncProgress = '';
    toast.success(total + '개 샵 데이터 동기화 완료');
    window.location.reload();
  };

  // dmUpload = async (item) => {
  //
  //   let res = await this.props.dmUplad({});
  //   console.log(res);
  // };

  onChangeModalInputs = async (event, targetObj) => {
    let { name, value } = event.target;
    targetObj[name] = value;
  };

  latestOderUpdate = async (item) => {
    let params = {
      store_id: this.store._id,
      shopNo: this.teamUser.selShopNo
    }
    this.props.latestOderUpdate(params, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        console.log(res.data);
      }
    });
  };

  adminCusData = async() => {
    let updateData = {
      store_id: this.store._id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
    }
    // console.log('updateMassReview', updateData);
    this.props.adminCusData(updateData, function(res) {
      console.log(res);

    });
  }

  @action
  toggleShopVisibility = (itemId) => {
    this.toggledShops[itemId] = !this.toggledShops[itemId];
  }

  @action
  toggleOrderDetailVisibility = (itemId) => {
    this.toggledOrders[itemId] = !this.toggledOrders[itemId];
  }

  // 주문일(day) 기준 프론트단 정렬 토글
  @action
  toggleOrderDaySort = () => {
    if (this.orderDaySort === null) {
      this.orderDaySort = 'asc';
    } else if (this.orderDaySort === 'asc') {
      this.orderDaySort = 'desc';
    } else {
      this.orderDaySort = null;
    }
    // 다른 정렬 해제
    this.payDaySort = null;
    this.orderCountSort = null;
  }

  // 최근 결제일(day) 기준 정렬 토글
  @action
  togglePayDaySort = () => {
    if (this.payDaySort === null) {
      this.payDaySort = 'asc';
    } else if (this.payDaySort === 'asc') {
      this.payDaySort = 'desc';
    } else {
      this.payDaySort = null;
    }
    // 다른 정렬 해제
    this.orderDaySort = null;
    this.orderCountSort = null;
  }

  // 샵 주문수 기준 정렬 토글
  @action
  toggleOrderCountSort = () => {
    if (this.orderCountSort === null) {
      this.orderCountSort = 'asc';
    } else if (this.orderCountSort === 'asc') {
      this.orderCountSort = 'desc';
    } else {
      this.orderCountSort = null;
    }
    // 다른 정렬 해제
    this.orderDaySort = null;
    this.payDaySort = null;
  }

  // 정렬된 리스트 반환
  getSortedDocs = () => {
    if (!this.list || !this.list.docs) return [];

    // 주문일 정렬
    if (this.orderDaySort !== null) {
      return [...this.list.docs].sort((a, b) => {
        const dayA = a.orderUpdatedAt ? moment(a.orderUpdatedAt).date() : 0;
        const dayB = b.orderUpdatedAt ? moment(b.orderUpdatedAt).date() : 0;
        return this.orderDaySort === 'asc' ? dayA - dayB : dayB - dayA;
      });
    }

    // 샵 주문수 정렬 (월평균 기준)
    if (this.orderCountSort !== null) {
      const getMonthlyAvg = (item) => {
        if (!item.periodOrderCount || item.periodOrderCount.orderCount === null) return 0;
        const months = item.periodOrderCount.start_date && item.periodOrderCount.end_date
          ? Math.max(Math.round(moment(item.periodOrderCount.end_date).diff(moment(item.periodOrderCount.start_date), 'days') / 30), 1) : 1;
        return Math.round(item.periodOrderCount.orderCount / months);
      };
      return [...this.list.docs].sort((a, b) => {
        const avgA = getMonthlyAvg(a);
        const avgB = getMonthlyAvg(b);
        return this.orderCountSort === 'asc' ? avgA - avgB : avgB - avgA;
      });
    }

    // 최근 결제일 정렬 (automatic_payment === 'T' 우선)
    if (this.payDaySort !== null) {
      const getPayDate = (item) => {
        if (!item.lastPaymentData || !item.lastPaymentData.length) return '';
        const getDate = (p) => p.pay_date || p.payment_date || p.paid_date || p.approval_date || p.order_date || p.created_date || '';
        const autoPayments = item.lastPaymentData.filter(p => p.automatic_payment === 'T');
        const sorted = (autoPayments.length > 0 ? autoPayments : item.lastPaymentData)
          .slice().sort((a, b) => getDate(b).localeCompare(getDate(a)));
        return getDate(sorted[0]);
      };
      return [...this.list.docs].sort((a, b) => {
        const dateA = getPayDate(a);
        const dateB = getPayDate(b);
        if (!dateA && !dateB) return 0;
        if (!dateA) return 1;
        if (!dateB) return -1;
        return this.payDaySort === 'asc' ? dateA.localeCompare(dateB) : dateB.localeCompare(dateA);
      });
    }

    return this.list.docs;
  }

  @action
  handleSearch = (event) => {
    event.preventDefault();
    const keyword = event.target.keyword.value.trim();

    if (!keyword) {
      toast.error('검색어를 입력해주세요.');
      return;
    }

    // 모든 필터 초기화
    this.searchFormValue.automaticPayment = false;
    this.searchFormValue.onepay = false;
    this.searchFormValue.isAll = false;
    this.searchFormValue.isFreeStore = false;
    this.searchFormValue.isSuspended = false;
    this.searchFormValue.isActiveSkin = false;

    // "전체 스토어" 탭 활성화
    this.searchFormValue.isAll = true;

    // searchParams 동기화
    this.listParams.searchParams.automaticPayment = false;
    this.listParams.searchParams.onepay = false;
    this.listParams.searchParams.isAll = true;
    this.listParams.searchParams.isFreeStore = false;
    this.listParams.searchParams.isSuspended = false;
    this.listParams.searchParams.isActiveSkin = false;

    // 검색어 설정
    this.listParams.searchParams.keyword = keyword;

    // 검색은 일회성 — 다음 접속시 유료샵 기본 화면으로 돌아갈 수 있도록 탭 저장하지 않음
    Storage.remove('shopList_selectedTab');

    // 리스트 조회
    this.getList();
  }

  getOrderFormPlatform = async (item) => {
    if(!item.selShop || !item.selShop.platformShopNo) {
      alert("shop을 선택해 주세요.")
      return false;
    }
    let params = {
      store_id: item.store_id._id,
      shopNo: item.selShop.platformShopNo
    }

    this.props.getOrderFormPlatform(params, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        console.log(res.data);
      }
    });
  };

  openImgDomainConfirm = (opts) => {
    const { storeId, shopNo, type, shop, storeName } = opts || {};
    if(!storeId || !shopNo) {
      alert("store 또는 shopNo가 없습니다.");
      return false;
    }
    this.modals.imgDomainConfirmData = {
      storeId,
      shopNo: parseInt(shopNo),
      type,
      storeName: storeName || '',
      shopName: (shop && shop.shopName) || '',
      primaryDomain: (shop && shop.primaryDomain) || '',
      baseDomain: (shop && shop.baseDomain) || '',
    };
    this.modals.isImgDomainConfirm = true;
  };

  runImgDomainUpdate = async () => {
    const d = this.modals.imgDomainConfirmData;
    if(!d) return;
    const fromDomain = (d.primaryDomain || '').trim();
    const toDomain = (d.baseDomain || '').trim();
    if(!fromDomain || !toDomain) {
      alert('변경 전/후 도메인을 모두 입력해 주세요.');
      return;
    }
    if(fromDomain === toDomain) {
      alert('변경 전/후 도메인이 동일합니다.');
      return;
    }
    const params = { store_id: d.storeId, shopNo: parseInt(d.shopNo), fromDomain, toDomain };
    this.isImgDomainRunning = true;
    const cb = (res) => {
      this.isImgDomainRunning = false;
      if(res && res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      } else {
        toast(`이미지 도메인 변경(${d.type}) 요청이 처리되었습니다. shop#${d.shopNo}`);
        this.modals.isImgDomainConfirm = false;
        this.modals.imgDomainConfirmData = null;
      }
    };
    if(d.type === "review") {
      this.props.adminReviewImgDomainUpdate(params, cb);
    } else if(d.type === "product") {
      this.props.adminProductImgDomainUpdate(params, cb);
    }
  };

  adminImgDomainUpdateByShop = (storeId, shopNo, type, shop, storeName) => {
    this.openImgDomainConfirm({ storeId, shopNo, type, shop, storeName });
  };

  adminImgDomainUpdate = async (item, type) => {
    let shopObj = item.selShop;
    let shopNo = shopObj && shopObj.platformShopNo;
    if(!shopNo) {
      shopNo = item.platformShopNo;
      if(shopNo) shopObj = item;
    }
    if(!shopNo && Array.isArray(item.vr_shop) && item.vr_shop.length > 0) {
      const active = item.vr_shop.find(s => s.active === 'T') || item.vr_shop[0];
      shopNo = active && active.platformShopNo;
      shopObj = active;
    }
    if(!shopNo && Array.isArray(item.paidShopNo) && item.paidShopNo.length > 0) {
      shopNo = item.paidShopNo[0];
    }
    if(!shopNo) {
      alert("shop 정보를 찾을 수 없습니다.")
      return false;
    }
    const storeId = (item.store_id && item.store_id._id) || item._id || item.id;
    const storeName = (item.store_id && item.store_id.name) || item.name || '';
    this.openImgDomainConfirm({ storeId, shopNo, type, shop: shopObj, storeName });
  };

  genThumbImg = async (item, type) => {
    console.log(item);
    let params = {
      store_id: item.store_id._id
    }
    this.props.genThumbImg(params, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        console.log(res.data);
      }
    });
  };

  dropDownToggle = async (target) => {
    if(target) {
      this.dropDowns[target] = !this.dropDowns[target];
    }
  };

  // 페이지 변경 핸들러
  @action
  handlePageChange = (pageNum) => {
    this.listParams.page = pageNum;
    this.getList();
  };

  render() {
    let _this = this;

    function PaginationInPage() {
      let result = [];
      let totalPages = _this.list.totalPages;
      let curPageNum = _this.list.page;
      let startNum = (parseInt((curPageNum-1)/10)*10) +1;
      let endNum = startNum+9 < totalPages ? startNum+9 : totalPages;

      let rendering = () => {
        for(let i = startNum; i <= endNum; i ++) {
          if(i === curPageNum) {
            result.push(
              <li key={i} className="on">
                <button type="button" className="sl-page-link" onClick={() => _this.handlePageChange(i)}>{i}</button>
              </li>
            );
          }
          else {
            result.push(
              <li key={i}>
                <button type="button" className="sl-page-link" onClick={() => _this.handlePageChange(i)}>{i}</button>
              </li>
            );
          }
        }
        return result;
      }

      if(_this.list && _this.list.totalPages) {
        return (
            <div className="pagination">
              <ul>
                { curPageNum !== 1 ?
                  <li className="btn-page-first">
                    <button type="button" className="sl-page-link" onClick={() => _this.handlePageChange(1)}>
                      <FeatherIcon icon="chevrons-left" className="nd-icon" />
                    </button>
                  </li> : null}
                { startNum - 1 > 0 ?
                  <li className="btn-page-prev">
                    <button type="button" className="sl-page-link" onClick={() => _this.handlePageChange(startNum-1)}>
                      <FeatherIcon icon="chevron-left" className="nd-icon" />
                    </button>
                  </li> : null}
                {rendering()}
                { endNum !== totalPages  ?
                  <li className="btn-page-next">
                    <button type="button" className="sl-page-link" onClick={() => _this.handlePageChange(startNum+10)}>
                      <FeatherIcon icon="chevron-right" className="nd-icon" />
                    </button>
                  </li> : null}
                { curPageNum !== totalPages ?
                  <li className="btn-page-last">
                    <button type="button" className="sl-page-link" onClick={() => _this.handlePageChange(totalPages)}>
                      <FeatherIcon icon="chevrons-right" className="nd-icon" />
                    </button>
                  </li> : null}
              </ul>
            </div>);
      }
      else {
        return (<></>);
      }

    }

    function getThisMonthPayDday(targetDate) {
      // 유효하지 않은 입력은 표시하지 않음 — moment(undefined)는 오늘이 되어 D-0으로 잘못 계산됨
      if (!targetDate) return null;
      const targetMoment = moment(targetDate);
      if (!targetMoment.isValid()) return null;

      // 이번 달 targetDate의 날짜로 설정
      const currentMonth = moment().startOf('month');
      const targetDay = targetMoment.date();
      const thisMonthTarget = currentMonth.clone().date(targetDay);

      // 오늘 날짜와 이번 달 목표 날짜의 차이 계산
      let dDay = thisMonthTarget.diff(moment().startOf('day'), 'days');

      if(dDay < 5 && dDay > -5) {
        dDay = (
            <strong className={"text-danger"}>{dDay + getMonthDifference(targetDate)}</strong>
        )
      }
      else {
        dDay = getMonthDifference(targetDate);
      }
      return dDay;
    }

    function PaymentItem(props) {
      let statusDom;
      //승인상태 (REG: 등록, REQ: 심사요청, APR: 승인, REJ: 반려)
      let item = props.paymentItem;
      let paymentStatus;
      switch (item.payment_status){
        case "paid" :
          paymentStatus = <Badge theme="info">결제완료</Badge>;
          break;
        default :
          paymentStatus = <Badge theme="info">{props.payment_status}</Badge>;
          break;
      }
      let automatic;
      switch (item.automatic_payment){
        case "T" :
          automatic = <Badge theme="info">구독</Badge>;
          break;
        default :
          automatic = <Badge theme="info">선결제</Badge>;
          break;
      }
      let method;
      switch (item.payment_method) {
        case "CARD" :
          method = <Badge theme="info">카드</Badge>;
          break;
        case "vcash" :
          method = <Badge theme="info">입금</Badge>;
          break;
        default :
          method = <Badge theme="info">{item.payment_method}</Badge>;
          break;
      }

      statusDom = <p>{(paymentStatus)} {automatic} {method} 결제일: {moment(item.pay_date).format('YYYY.MM.DD')}, 금액: {new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(item.payment_amount)}</p>
      return statusDom;
    }

    function GetOrderType(props) {
      let statusDom = '';
      //승인상태 (REG: 등록, REQ: 심사요청, APR: 승인, REJ: 반려)
      switch (props.orderType){
        case "free" :
          statusDom = <Badge theme="info">무료</Badge>;
          break;
        case "autoPayment" :
          statusDom = <Badge theme="danger">구독</Badge>;
          break;
        case "regular" :
          statusDom = <Badge theme="danger">구독</Badge>;
          break;
        case "event" :
          statusDom = <Badge>선결제</Badge>;
          break;
        case "event_4p2_first" :
          statusDom = <Badge>선결제</Badge>;
          break;
        case "event_6p6_first" :
          statusDom = <Badge>선결제</Badge>;
          break;
        case "반려" :
          statusDom = <Badge outline theme="info">반려</Badge>;
          break;
        default :
          statusDom = <Badge outline theme="info">{props.orderType}</Badge>;
          break;
      }
      return statusDom;
    }


    function GetThisMonthPayDday(props) {
      let targetDate = props.targetDate;
      let payType = props.payType;
      if(!targetDate) {
        return "?"
      }
      if(payType === "autoPayment" || payType === "regular") {
        // 이번 달 targetDate의 날짜로 설정
        const currentMonth = moment().startOf('month');
        const targetDay = moment(targetDate).date();
        const thisMonthTarget = currentMonth.clone().date(targetDay);

        // 오늘 날짜와 이번 달 목표 날짜의 차이 계산
        let dDay = thisMonthTarget.diff(moment().startOf('day'), 'days');

        if(dDay < 5 && dDay > -5) {
          dDay = (
              <strong className={"text-danger"}>{dDay + getMonthDifference(targetDate)}</strong>
          )
        }
        else {
          dDay = getMonthDifference(targetDate);
        }
        return dDay;
      }
      else {
        // 시간을 제거하고 날짜만으로 일수 차이 계산
        let dDay = moment(targetDate).startOf('day').diff(moment().startOf('day'), 'days');
        if(dDay < 30 && dDay > -7) {
          dDay = (
              <strong className={"text-danger"}>~{moment(targetDate).format("YYYY.MM.DD") + "(" + dDay + ")"}</strong>
          )
        }
        else {
          dDay = (
              <span>~{moment(targetDate).format("YYYY.MM.DD") + "(" + dDay + ")"}</span>
          )
        }
        return dDay;
      }

    }

    function getMonthDifference(targetDate) {
      const today = moment().startOf('day'); // 오늘 날짜 (시간 제거)
      const target = moment(targetDate).startOf('day'); // 특정 날짜 (시간 제거)
      const diff = today.diff(target, 'months')+1; // 월 차이 계산

      return "(" + Math.max(0, diff) + ")"; // 음수 방지
    }

    // 최근 구독 항목 (구독 결제 중 pay_date가 가장 최근인 1건)
    function getLatestSubscriptionItem(orderStatus) {
      if (!orderStatus || orderStatus.length === 0) return null;
      const subs = orderStatus.filter(item =>
        item.automatic_payment === "T" && item.payment_status === "paid" && item.pay_date
      );
      if (subs.length === 0) return null;
      return subs.slice().sort((a, b) =>
        moment(b.pay_date).valueOf() - moment(a.pay_date).valueOf()
      )[0];
    }

    // 같은 달인지 비교 (시간 무시, YYYY-MM 까지만)
    function isSameMonthByDate(date) {
      if (!date) return false;
      return moment(date).format('YYYY-MM') === moment().format('YYYY-MM');
    }

    // 이번 달 구독 결제 여부 판단 함수 (상세 모달용 - orderStatus 배열 사용)
    // 구독(automatic_payment === 'T') 항목 중 가장 최근 결제일이 이번 달인지 확인 (시간 제외)
    function isThisMonthSubscriptionPaid(orderStatus) {
      const latest = getLatestSubscriptionItem(orderStatus);
      if (!latest) return false;
      return isSameMonthByDate(latest.pay_date);
    }

    // 이번 달 구독 결제 여부 판단 함수 (리스트용 - item.orderUpdatedAt 사용)
    // 구독(automaticPayment === 'T') 인 경우에만 판단, 선결제(F) 는 항상 false
    function isThisMonthPaidFromOrder(inAppOrder, orderUpdatedAt) {
      if (!inAppOrder || !orderUpdatedAt) return false;

      // 선결제(automaticPayment === 'F') 는 이번 달 결제 판단 대상에서 제외 — 구독만 기준
      if (inAppOrder.automaticPayment !== "T") return false;

      // 시간은 보지 않고 일(년-월)까지만 비교
      return isSameMonthByDate(orderUpdatedAt);
    }

    // 구독 샵 결제 현황 계산
    let paidCount = 0;
    let totalCount = 0;
    if(this.searchFormValue.automaticPayment && this.list && this.list.docs) {
      totalCount = this.list.docs.length;
      paidCount = this.list.docs.filter(item => {
        return item.isPaymentThisMonth !== undefined
          ? item.isPaymentThisMonth
          : isThisMonthPaidFromOrder(item.inAppOrder_id, item.orderUpdatedAt);
      }).length;
    }

    return (
      <div className="main-content">
        <PageTitle />
        <div style={{display: 'flex', justifyContent: 'flex-end', gap: 6, padding: '0 16px 8px', marginTop: -8}}>
          <Button theme="light" size="sm" onClick={() => this.openMailTpl()}>
            <FeatherIcon icon="mail" size="13" style={{verticalAlign: '-2px', marginRight: 4}}/>
            메일 템플릿 관리
          </Button>
          <Button theme="light" size="sm" onClick={() => this.openSmsTpl()}>
            <FeatherIcon icon="message-square" size="13" style={{verticalAlign: '-2px', marginRight: 4}}/>
            문자 템플릿 관리
          </Button>
        </div>
        <div className="user-list-box">
          <div className="section-box shop-search-filter">
            <form onSubmit={this.handleSearch}>
              <div className="search-filter-row">
                {/* 검색 영역 */}
                <div className="search-col">
                  <span className="col-label"><FeatherIcon icon="search" size="14" className="col-icon"/>검색</span>
                  <div className="search-input-wrap">
                    <InputGroup>
                      <FormInput
                        type="text"
                        name="keyword"
                        defaultValue={this.listParams.searchParams.keyword || ''}
                        placeholder="스토어명, 대표자명, platformId, 도메인 등"
                      />
                      <InputGroupAddon type="append">
                        <Button type="submit" theme="primary">검색</Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </div>
                </div>

                {/* 필터 영역 */}
                <div className="filter-col">
                  <span className="col-label"><FeatherIcon icon="filter" size="14" className="col-icon"/>필터</span>
                  <ButtonGroup>
                        <Button
                          theme={!this.searchFormValue.automaticPayment && !this.searchFormValue.onepay && !this.searchFormValue.isFreeStore ? "primary" : "secondary"}
                          outline={this.searchFormValue.automaticPayment || this.searchFormValue.onepay || this.searchFormValue.isFreeStore}
                          onClick={() => {
                            // 모든 필터 초기화
                            this.searchFormValue.automaticPayment = false;
                            this.searchFormValue.onepay = false;
                            this.searchFormValue.isAll = false;
                            this.searchFormValue.isFreeStore = false;
                            this.searchFormValue.isSuspended = false;
                            this.searchFormValue.isActiveSkin = false;

                            // searchParams 동기화
                            this.listParams.searchParams.isPaidUser = true;
                            this.listParams.searchParams.automaticPayment = false;
                            this.listParams.searchParams.onepay = false;
                            this.listParams.searchParams.isAll = false;
                            this.listParams.searchParams.isFreeStore = false;
                            this.listParams.searchParams.isSuspended = false;
                            this.listParams.searchParams.isActiveSkin = false;

                            // 검색어 제거
                            delete this.listParams.searchParams.keyword;

                            // localStorage에서 저장된 탭 제거
                            Storage.remove('shopList_selectedTab');

                            this.getList();
                          }}
                        >
                          유료샵
                        </Button>

                        <Button
                          theme={this.searchFormValue.automaticPayment ? "primary" : "secondary"}
                          outline={!this.searchFormValue.automaticPayment}
                          onClick={() => {
                            // 모든 필터 초기화
                            this.searchFormValue.automaticPayment = false;
                            this.searchFormValue.onepay = false;
                            this.searchFormValue.isAll = false;
                            this.searchFormValue.isFreeStore = false;
                            this.searchFormValue.isSuspended = false;
                            this.searchFormValue.isActiveSkin = false;

                            // 선택한 필터만 활성화
                            this.searchFormValue.automaticPayment = true;

                            // searchParams 동기화
                            this.listParams.searchParams.isPaidUser = true;
                            this.listParams.searchParams.automaticPayment = true;
                            this.listParams.searchParams.onepay = false;
                            this.listParams.searchParams.isAll = false;
                            this.listParams.searchParams.isFreeStore = false;
                            this.listParams.searchParams.isSuspended = false;
                            this.listParams.searchParams.isActiveSkin = false;

                            // 검색어 제거
                            delete this.listParams.searchParams.keyword;

                            // localStorage에 선택된 탭 저장
                            Storage.set('shopList_selectedTab', 'automaticPayment');

                            this.getList();
                          }}
                        >
                          구독 샵
                        </Button>

                        <Button
                          theme={this.searchFormValue.onepay ? "primary" : "secondary"}
                          outline={!this.searchFormValue.onepay}
                          onClick={() => {
                            // 모든 필터 초기화
                            this.searchFormValue.automaticPayment = false;
                            this.searchFormValue.onepay = false;
                            this.searchFormValue.isAll = false;
                            this.searchFormValue.isFreeStore = false;
                            this.searchFormValue.isSuspended = false;
                            this.searchFormValue.isActiveSkin = false;

                            // 선택한 필터만 활성화
                            this.searchFormValue.onepay = true;

                            // searchParams 동기화
                            this.listParams.searchParams.isPaidUser = true;
                            this.listParams.searchParams.automaticPayment = false;
                            this.listParams.searchParams.onepay = true;
                            this.listParams.searchParams.isAll = false;
                            this.listParams.searchParams.isFreeStore = false;
                            this.listParams.searchParams.isSuspended = false;
                            this.listParams.searchParams.isActiveSkin = false;

                            // 선결제 샵은 사용완료순 기본 정렬
                            this.listParams.sort = 'useExpiryDate';

                            // 검색어 제거
                            delete this.listParams.searchParams.keyword;

                            // localStorage에 선택된 탭 저장
                            Storage.set('shopList_selectedTab', 'onepay');

                            this.getList();
                          }}
                        >
                          선결제 샵
                        </Button>

                        <Button
                          theme={this.searchFormValue.isFreeStore ? "primary" : "secondary"}
                          outline={!this.searchFormValue.isFreeStore}
                          onClick={() => {
                            // 모든 필터 초기화
                            this.searchFormValue.automaticPayment = false;
                            this.searchFormValue.onepay = false;
                            this.searchFormValue.isAll = false;
                            this.searchFormValue.isFreeStore = false;
                            this.searchFormValue.isSuspended = false;
                            this.searchFormValue.isActiveSkin = false;
                            this.searchFormValue.isPaidUser = true;

                            // 선택한 필터만 활성화
                            this.searchFormValue.isFreeStore = true;

                            // searchParams 동기화
                            this.listParams.searchParams.automaticPayment = false;
                            this.listParams.searchParams.onepay = false;
                            this.listParams.searchParams.isAll = false;
                            this.listParams.searchParams.isFreeStore = true;
                            this.listParams.searchParams.isSuspended = false;
                            this.listParams.searchParams.isActiveSkin = false;
                            this.listParams.searchParams.isPaidUser = true;

                            // 검색어 제거
                            delete this.listParams.searchParams.keyword;

                            // localStorage에 선택된 탭 저장
                            Storage.set('shopList_selectedTab', 'isFreeStore');

                            this.getList();
                          }}
                        >
                          무료 샵
                        </Button>
                      </ButtonGroup>
                </div>
              </div>
            </form>
          </div>

          {/* 리스트 영역 */}
          <div className="section-box" style={{padding: '0'}}>
            <form>
              <div className="user-list-table">
                {/* 툴바 */}
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', borderBottom: '1px solid #e8ecf4', backgroundColor: '#fafbfc'}}>
                  <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                    <span style={{fontSize: '13px', color: '#495057'}}>
                      검색결과 <strong style={{color: '#5664D2'}}>{this.list.totalDocs}</strong>개
                      {this.searchFormValue.automaticPayment && totalCount > 0 ?
                        <span style={{marginLeft: '8px', fontSize: '12px', color: '#6c757d'}}>(결제: <strong style={{color: '#28a745'}}>{paidCount}</strong>/{totalCount})</span>
                      : ''}
                    </span>
                    {this.searchFormValue.automaticPayment && (
                      <Button
                        size="sm"
                        theme={this.isBatchSyncing ? "light" : "info"}
                        disabled={this.isBatchSyncing}
                        onClick={() => this.batchSyncStoreDetails()}
                        style={{fontSize: '11px', padding: '3px 10px'}}
                      >
                        {this.isBatchSyncing ? (
                          <><FeatherIcon icon="loader" size="12" style={{marginRight: '4px', animation: 'spin 1s linear infinite'}}/>{this.batchSyncProgress}</>
                        ) : (
                          <><FeatherIcon icon="refresh-cw" size="12" style={{marginRight: '4px'}}/>일괄 동기화</>
                        )}
                      </Button>
                    )}
                  </div>
                  <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                    {/* 뷰 모드 */}
                    <ButtonGroup size="sm">
                      <Button
                        theme={this.storageCfg.etcType === "read" ? "primary" : "white"}
                        onClick={event => this.onChangeStorageCfg(this.storageCfg, 'read', 'etcType')}
                        style={{fontSize: '12px', padding: '4px 10px'}}
                      >
                        <FeatherIcon icon="eye" size="12" style={{marginRight: '3px'}}/>정보
                      </Button>
                      <Button
                        theme={this.storageCfg.etcType === "fn" ? "primary" : "white"}
                        onClick={event => this.onChangeStorageCfg(this.storageCfg, 'fn', 'etcType')}
                        style={{fontSize: '12px', padding: '4px 10px'}}
                      >
                        <FeatherIcon icon="tool" size="12" style={{marginRight: '3px'}}/>기능
                      </Button>
                      <Button
                        theme={this.storageCfg.etcType === "input" ? "primary" : "white"}
                        onClick={event => this.onChangeStorageCfg(this.storageCfg, 'input', 'etcType')}
                        style={{fontSize: '12px', padding: '4px 10px'}}
                      >
                        <FeatherIcon icon="edit-3" size="12" style={{marginRight: '3px'}}/>메모
                      </Button>
                    </ButtonGroup>

                    {/* 정렬 & 페이지 수 */}
                    <FormSelect
                      name="limit"
                      value={this.listParams.limit}
                      onChange={event => {
                        this.listParams.limit = parseInt(event.target.value);
                        this.onChangeSearchValue(event, this.listParams);
                      }}
                      style={{width: '120px', height: '32px', fontSize: '12px'}}
                    >
                      <option value="20">20개씩</option>
                      <option value="50">50개씩</option>
                      <option value="100">100개씩</option>
                      <option value="200">200개씩</option>
                    </FormSelect>
                    <FormSelect
                      name="sort"
                      value={this.listParams.sort}
                      onChange={event => {
                        this.listParams.sort = event.target.value;
                        this.onChangeSearchValue(event, this.listParams);
                      }}
                      style={{width: '120px', height: '32px', fontSize: '12px'}}
                    >
                      <option value="signedUpAt">가입순</option>
                      <option value="useExpiryDate">사용완료순</option>
                    </FormSelect>
                  </div>
                </div>
                {/* 검색어가 있으면 isAll 이어도 유료샵 탭과 동일한 일반 리스트 형식으로 노출 */}
                {(this.listParams.searchParams.isAll && !this.listParams.searchParams.keyword) ? (
                    <table className="store-list">
                      <colgroup>
                        <col width="10%"/>
                        <col width="10%"/>
                        <col width="5%"/>
                        <col width="5%"/>
                        <col width="12%"/>
                        <col width="14%"/>
                        <col width="6%"/>
                        <col width="6%"/>
                        <col width="10%"/>
                        <col width=""/>
                      </colgroup>
                      <thead>
                      <tr>
                        <th>관리자 정보</th>
                        <th>연락 정보</th>
                        <th>결제 ShopNo</th>
                        <th>활성 스킨</th>
                        <th>vr_shop 정보</th>
                        <th>주문 정보</th>
                        <th>로그인</th>
                        <th>상세</th>
                        <th>이미지 도메인변경</th>
                        <th>비고</th>
                      </tr>
                      </thead>
                      <tbody>
                      {this.list && this.list.docs && this.list.docs.length > 0 ?
                          this.list.docs.map((item, i) => (
                              <tr key={i}>
                                {/* 관리자 정보 */}
                                <td className={item.isDelApp ? "text-red" : ""}>{item.domain ? (
                                    <a className={item.isDelApp ? "text-red" : ""} href={"https://" + item.domain} target="_blank" rel="noopener noreferrer">{item.name}({item.presidentName})</a>
                                ) : (
                                    <a className={item.isDelApp ? "text-red" : ""} href={"https://" + item.platformId + ".cafe24.com"}
                                       target="_blank" rel="noopener noreferrer">{item.name}({item.presidentName})</a>
                                )} / {item.platformId}</td>
                                {/* 연락 정보 */}
                                <td>{item.notificationEmail ? item.notificationEmail : item.email} / {item.tel ? item.tel : "-"}</td>
                                {/* 결제 ShopNo */}
                                <td>{Array.isArray(item.paidShopNo) ? item.paidShopNo.join(', ') : ""}</td>
                                {/* 활성 스킨 */}
                                <td>{item.vr_skin ? item.vr_skin.length : 0}</td>
                                {/* vr_shop 정보 */}
                                <td>
                                  {item.vr_shop && item.vr_shop.length > 0 ? (
                                      <>
                                        {(() => {
                                          const activeShops = item.vr_shop.filter(shop => shop.active === 'T');
                                          const inactiveShops = item.vr_shop.filter(shop => shop.active !== 'T');
                                          const isToggled = this.toggledShops[item._id];

                                          return (
                                              <>
                                                {activeShops.map((shop, idx) => (
                                                    <div key={`active-${idx}`} style={{marginBottom: '5px', fontSize: '11px'}}>
                                                      <div><strong style={{color: '#28a745'}}>{shop.shopName}</strong> (Shop#{shop.platformShopNo})</div>
                                                      <div>도메인: {shop.primaryDomain || shop.baseDomain}</div>
                                                      <div>활성: O / 연결: {shop.siteConnect === 'T' ? 'O' : 'X'}</div>
                                                      {shop.orderName && <div>플랜: {shop.orderName} / {shop.orderPrice ? shop.orderPrice.toLocaleString() + '원' : '-'}</div>}
                                                      <div>리뷰 부스터 애드온: {(shop.entitlements && shop.entitlements.reviewWriteAddon) ? <span style={{color: '#28a745', fontWeight: 700}}>부여</span> : <span style={{color: '#adb5bd'}}>미부여</span>}</div>
                                                      {shop.orderUpdatedAt && <div>주문갱신: {moment(shop.orderUpdatedAt).format('YY.MM.DD')}</div>}
                                                      {shop.cancelledAt && <div style={{color: '#dc3545'}}>구독취소일: {moment(shop.cancelledAt).format('YY.MM.DD HH:mm')}</div>}
                                                      {(idx < activeShops.length - 1 || (inactiveShops.length > 0 && isToggled)) && <hr style={{margin: '3px 0'}}/>}
                                                    </div>
                                                ))}

                                                {inactiveShops.length > 0 && (
                                                    <>
                                                      <Button
                                                        size="sm"
                                                        outline
                                                        theme="secondary"
                                                        onClick={() => this.toggleShopVisibility(item._id)}
                                                        style={{fontSize: '10px', padding: '2px 6px', marginTop: '3px'}}
                                                      >
                                                        {isToggled ? `비활성 샵 숨기기 (${inactiveShops.length})` : `비활성 샵 보기 (${inactiveShops.length})`}
                                                      </Button>

                                                      {isToggled && inactiveShops.map((shop, idx) => (
                                                          <div key={`inactive-${idx}`} style={{marginBottom: '5px', fontSize: '11px', marginTop: '5px', opacity: 0.6}}>
                                                            <div><strong style={{color: '#6c757d'}}>{shop.shopName}</strong> (Shop#{shop.platformShopNo})</div>
                                                            <div>도메인: {shop.primaryDomain || shop.baseDomain}</div>
                                                            <div>활성: X / 연결: {shop.siteConnect === 'T' ? 'O' : 'X'}</div>
                                                            {shop.orderName && <div>플랜: {shop.orderName} / {shop.orderPrice ? shop.orderPrice.toLocaleString() + '원' : '-'}</div>}
                                                            <div>리뷰 부스터 애드온: {(shop.entitlements && shop.entitlements.reviewWriteAddon) ? <span style={{color: '#28a745', fontWeight: 700}}>부여</span> : <span style={{color: '#adb5bd'}}>미부여</span>}</div>
                                                            {shop.orderUpdatedAt && <div>주문갱신: {moment(shop.orderUpdatedAt).format('YY.MM.DD')}</div>}
                                                            {shop.cancelledAt && <div style={{color: '#dc3545'}}>구독취소일: {moment(shop.cancelledAt).format('YY.MM.DD HH:mm')}</div>}
                                                            {idx < inactiveShops.length - 1 && <hr style={{margin: '3px 0'}}/>}
                                                          </div>
                                                      ))}
                                                    </>
                                                )}
                                              </>
                                          );
                                        })()}
                                      </>
                                  ) : '-'}
                                </td>
                                {/* 주문 정보 */}
                                <td style={{fontSize: '11px'}}>
                                  {(() => {
                                    const hasLastInAppOrder = item.lastInAppOrder_id;
                                    const isOrderToggled = this.toggledOrders[item._id];

                                    return (
                                      <>
                                        {item.inAppOrder_ids && item.inAppOrder_ids.length > 0 ? (
                                            <>
                                              {item.inAppOrder_ids && item.inAppOrder_ids.map((inAppOrder, idx) => {
                                                if(!inAppOrder.updatedAt) return null;
                                                const nextPayDday = moment(inAppOrder.endDate).diff(moment(), 'days') > 10000 ?
                                                  getThisMonthPayDday(inAppOrder.inAppOrderupdatedAt || inAppOrder.updatedAt) : null;
                                                return (
                                                    <div key={idx} style={{marginBottom: '5px'}}>
                                                      <div><strong>{inAppOrder.orderName}</strong> / {moment(inAppOrder.inAppOrderupdatedAt ? inAppOrder.inAppOrderupdatedAt : inAppOrder.updatedAt).format('YYYY.MM.DD')}</div>
                                                      {nextPayDday && (
                                                        <div style={{color: '#0066cc', fontWeight: 'bold'}}>다음 결제일: {nextPayDday}</div>
                                                      )}
                                                    </div>
                                                );
                                              })}
                                            </>
                                        ) : (
                                            <>
                                              {item.isPaidUser && item.lastInAppOrder_id ? (
                                                <div>
                                                  <div><strong>{item.orderName}</strong> / {moment(item.lastInAppOrder_id.inAppOrderupdatedAt).format('YYYY.MM.DD')}</div>
                                                  {moment(item.useExpiryDate).diff(moment(), 'days') > 10000 && (
                                                    <div style={{color: '#0066cc', fontWeight: 'bold'}}>
                                                      다음 결제일: {getThisMonthPayDday(item.lastInAppOrder_id.inAppOrderupdatedAt || item.lastInAppOrder_id.updatedAt)}
                                                    </div>
                                                  )}
                                                </div>
                                              ) : " - "}
                                            </>
                                        )}

                                        {hasLastInAppOrder && (
                                          <>
                                            <Button
                                              size="sm"
                                              outline
                                              theme="info"
                                              onClick={() => this.toggleOrderDetailVisibility(item._id)}
                                              style={{fontSize: '10px', padding: '2px 6px', marginTop: '5px'}}
                                            >
                                              {isOrderToggled ? '상세 숨기기' : '상세 보기'}
                                            </Button>

                                            {isOrderToggled && (
                                              <div style={{marginTop: '5px', padding: '8px', backgroundColor: '#f8f9fa', borderRadius: '4px', fontSize: '11px'}}>
                                                <div><strong>{item.lastInAppOrder_id.orderName}</strong> ({item.lastInAppOrder_id.plan})</div>
                                                <div>금액: {item.lastInAppOrder_id.orderAmount ? item.lastInAppOrder_id.orderAmount.toLocaleString() : '-'}원</div>
                                                {item.lastInAppOrder_id.orderOrgAmount && item.lastInAppOrder_id.orderSaleAmount && (
                                                    <div>할인: {item.lastInAppOrder_id.orderOrgAmount.toLocaleString()}원 → {item.lastInAppOrder_id.orderSaleAmount.toLocaleString()}원</div>
                                                )}
                                                <div>타입: {item.lastInAppOrder_id.payType} / {item.lastInAppOrder_id.automaticPayment === 'T' ? '자동결제' : '수동결제'}</div>
                                                <div>시작: {moment(item.lastInAppOrder_id.startDate).format('YY.MM.DD')}</div>
                                                <div>종료: {moment(item.lastInAppOrder_id.endDate).format('YY.MM.DD')}</div>
                                                {item.lastInAppOrder_id.nextPayDate && (
                                                    <div>다음결제: {moment(item.lastInAppOrder_id.nextPayDate).format('YY.MM.DD')}</div>
                                                )}
                                                <div>갱신: {moment(item.lastInAppOrder_id.inAppOrderupdatedAt || item.lastInAppOrder_id.updatedAt).format('YY.MM.DD HH:mm')}</div>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </>
                                    );
                                  })()}
                                </td>
                                {/* 로그인 */}
                                <td className="text-center">
                                  <ButtonGroup>
                                    <Button onClick={e => this.csLogin(item)}>login</Button>
                                  </ButtonGroup>
                                </td>
                                {/* 상세 */}
                                <td className="text-center">
                                  <ButtonGroup>
                                    <Button onClick={e => this.modalToggle('isStoreDetail', item)}>상세</Button>
                                  </ButtonGroup>
                                </td>
                                {/* 이미지 도메인변경 */}
                                <td className="text-center">
                                  {(() => {
                                    const activeShops = (item.vr_shop || []).filter(shop => shop.active === 'T');
                                    if (activeShops.length === 0) return <span className="text-muted">-</span>;
                                    return activeShops.map((shop, idx) => (
                                      <div key={idx} style={{marginBottom: activeShops.length > 1 ? '4px' : 0}}>
                                        {activeShops.length > 1 && (
                                          <div style={{fontSize: '10px', color: '#6c757d'}}>Shop#{shop.platformShopNo}</div>
                                        )}
                                        <ButtonGroup size="sm">
                                          <Button onClick={e => this.adminImgDomainUpdateByShop(item._id, shop.platformShopNo, 'review', shop, item.name)}>리뷰</Button>
                                          <Button onClick={e => this.adminImgDomainUpdateByShop(item._id, shop.platformShopNo, 'product', shop, item.name)}>상품</Button>
                                        </ButtonGroup>
                                      </div>
                                    ));
                                  })()}
                                </td>
                                {/* 비고 */}
                                <td className="text-left">
                                  <div>
                                    <InputGroup>
                                      <FormInput name="memo" placeholder="메모" onChange={event => {
                                        this.onChangeMemoValue(event, item)
                                      }} value={item.memo ? item.memo : ""} className="table-input-text"/>
                                      <InputGroupAddon type="append"><Button theme="secondary" onClick={e => {
                                        this.updateStoreMemo(item)
                                      }}>업데이트</Button></InputGroupAddon>
                                    </InputGroup>
                                  </div>
                                  {item.isApplyDelStoreAccount ? (
                                      <div className="btn-wrap">
                                        <Button outline theme="danger"
                                                onClick={event => this.withdrawal(item)}>탈퇴처리</Button>
                                      </div>
                                  ) : null}
                                </td>
                              </tr>))
                          :
                          <tr>
                            <td colSpan={10} className="text-center">가입한 스토어가 없습니다</td>
                          </tr>
                      }

                      </tbody>
                    </table>
                ) : (
                <>
                  {/*
                    etcType 모드 설명:
                    - "fn" (기능): 주문정보, 이미지 도메인변경, 썸네일 생성 등 관리 기능 제공
                    - "read" (정보): 연락처, 활성 스킨수, 주문 정보를 읽기 전용으로 표시 (login 버튼 숨김)
                    - "input" (메모): 메모 입력 기능만 제공
                  */}
                <table className="store-list">
                  <colgroup>
                    <col width=""/>
                    <col width="9%"/>
                    {/* fn 모드: 주문 정보 + 관리 기능 컬럼 */}
                    {this.storageCfg.etcType === "fn" ? (<>
                      <col width="7%"/>
                      <col width="10%"/>
                      <col width="10%"/>
                      <col width="7%"/>
                      <col width=""/>
                      <col width=""/>
                      <col width=""/>
                    </>) : this.storageCfg.etcType === "read" ? (<>
                      {/* read 모드 */}
                      <col width="4%"/>
                      <col width="6%"/>
                      <col width="14%"/>
                      <col width="13%"/>
                      <col width="10%"/>
                    </>) : (<></>)}
                    {this.searchFormValue.automaticPayment && <col width="10%"/>}
                    <col width="16%"/>
                  </colgroup>
                  <thead>
                  <tr>
                    {/*<th>플렛폼 정보</th>*/}
                    <th>스토어 정보</th>
                    <th>샵</th>
                    {/* fn 모드: 모든 관리 기능 */}
                    {this.storageCfg.etcType === "fn" ? (<>
                      <th style={{cursor: 'pointer', userSelect: 'none'}} onClick={() => this.toggleOrderDaySort()}>
                        주문일(day)
                        {this.orderDaySort === 'asc' ? (
                          <FeatherIcon icon="chevron-up" size="14" style={{marginLeft: '3px'}}/>
                        ) : this.orderDaySort === 'desc' ? (
                          <FeatherIcon icon="chevron-down" size="14" style={{marginLeft: '3px'}}/>
                        ) : (
                          <FeatherIcon icon="minus" size="14" style={{marginLeft: '3px', opacity: 0.5}}/>
                        )}
                      </th>
                      <th>주문상세 / 사용기간</th>
                      <th style={{cursor: 'pointer', userSelect: 'none'}} onClick={() => this.toggleOrderCountSort()}>
                        샵 주문수
                        {this.orderCountSort === 'asc' ? (
                          <FeatherIcon icon="chevron-up" size="14" style={{marginLeft: '3px'}}/>
                        ) : this.orderCountSort === 'desc' ? (
                          <FeatherIcon icon="chevron-down" size="14" style={{marginLeft: '3px'}}/>
                        ) : (
                          <FeatherIcon icon="minus" size="14" style={{marginLeft: '3px', opacity: 0.5}}/>
                        )}
                      </th>
                      <th style={{cursor: 'pointer', userSelect: 'none'}} onClick={() => this.togglePayDaySort()}>
                        최근 결제일(day)
                        {this.payDaySort === 'asc' ? (
                          <FeatherIcon icon="chevron-up" size="14" style={{marginLeft: '3px'}}/>
                        ) : this.payDaySort === 'desc' ? (
                          <FeatherIcon icon="chevron-down" size="14" style={{marginLeft: '3px'}}/>
                        ) : (
                          <FeatherIcon icon="minus" size="14" style={{marginLeft: '3px', opacity: 0.5}}/>
                        )}
                      </th>
                      {/* 이번달 결제 (최근 결제일 바로 오른쪽) */}
                      {this.renderThisMonthPayTh()}
                      <th>주문정보</th>
                      <th>이미지 도메인변경</th>
                      <th>이미지 썸네일</th>
                    </>) : this.storageCfg.etcType === "read" ? (<>
                      {/* read 모드: 읽기 전용 주문 정보 */}
                      <th>활성 스킨수</th>
                      <th style={{cursor: 'pointer', userSelect: 'none'}} onClick={() => this.toggleOrderDaySort()}>
                        주문일(day)
                        {this.orderDaySort === 'asc' ? (
                          <FeatherIcon icon="chevron-up" size="14" style={{marginLeft: '3px'}}/>
                        ) : this.orderDaySort === 'desc' ? (
                          <FeatherIcon icon="chevron-down" size="14" style={{marginLeft: '3px'}}/>
                        ) : (
                          <FeatherIcon icon="minus" size="14" style={{marginLeft: '3px', opacity: 0.5}}/>
                        )}
                      </th>
                      <th>주문상세 / 사용기간</th>
                      <th style={{cursor: 'pointer', userSelect: 'none'}} onClick={() => this.toggleOrderCountSort()}>
                        샵 주문수
                        {this.orderCountSort === 'asc' ? (
                          <FeatherIcon icon="chevron-up" size="14" style={{marginLeft: '3px'}}/>
                        ) : this.orderCountSort === 'desc' ? (
                          <FeatherIcon icon="chevron-down" size="14" style={{marginLeft: '3px'}}/>
                        ) : (
                          <FeatherIcon icon="minus" size="14" style={{marginLeft: '3px', opacity: 0.5}}/>
                        )}
                      </th>
                      <th style={{cursor: 'pointer', userSelect: 'none'}} onClick={() => this.togglePayDaySort()}>
                        최근 결제일(day)
                        {this.payDaySort === 'asc' ? (
                          <FeatherIcon icon="chevron-up" size="14" style={{marginLeft: '3px'}}/>
                        ) : this.payDaySort === 'desc' ? (
                          <FeatherIcon icon="chevron-down" size="14" style={{marginLeft: '3px'}}/>
                        ) : (
                          <FeatherIcon icon="minus" size="14" style={{marginLeft: '3px', opacity: 0.5}}/>
                        )}
                      </th>
                      {/* 이번달 결제 (최근 결제일 바로 오른쪽) */}
                      {this.renderThisMonthPayTh()}
                    </>) : (<></>)}
                    <th>기능</th>
                  </tr>
                  </thead>
                  <tbody>
                  {this.list && this.list.docs && this.list.docs.length > 0 ?
                      this.getSortedDocs().map((item, i) => {
                        // 데이터 누락 가드 — store_id 또는 platformShopNo 가 없는 row 는 간소 행으로 표시 (테이블 깨짐 방지)
                        const isMissing = !item || !item.store_id || !item.store_id._id || item.platformShopNo === null;
                        if (isMissing) {
                          const fnExtra = this.storageCfg.etcType === 'fn' ? 7 : this.storageCfg.etcType === 'read' ? 5 : 0;
                          const totalCols = 2 + fnExtra + (this.searchFormValue.automaticPayment ? 1 : 0) + 1;
                          return (
                            <tr key={i} style={{background: '#FFF7ED'}}>
                              <td colSpan={totalCols} style={{fontSize: '12px', color: '#92400E', padding: '10px 14px'}}>
                                <FeatherIcon icon="alert-triangle" size="13" style={{verticalAlign: '-2px', marginRight: 6}}/>
                                연동된 스토어 정보가 없습니다.
                                {item && item._id ? <span style={{marginLeft: 8, color: '#9CA3AF', fontFamily: 'monospace'}}>샵 id: {item._id}</span> : null}
                                {item && item.shopName ? <span style={{marginLeft: 8}}>{item.shopName}</span> : null}
                              </td>
                            </tr>
                          );
                        }
                        return (
                          <tr key={i} style={
                            this.searchFormValue.automaticPayment &&
                            !(item.isPaymentThisMonth !== undefined ? item.isPaymentThisMonth : isThisMonthPaidFromOrder(item.inAppOrder_id, item.orderUpdatedAt))
                              ? {backgroundColor: '#fff3cd'}
                              : {}
                          }>
                            {/* 스토어 정보 (스토어명 + ID + 연락처 + 타입) */}
                            {item.store_id ? (
                                <td className={item.store_id.isDelApp ? "text-red" : ""} style={{fontSize: '11px', lineHeight: '18px'}}>
                                  <div style={{fontWeight: '600'}}>
                                    {item.primaryDomain ? (
                                      <a className={item.store_id.isDelApp ? "text-red" : ""} href={"https://" + item.primaryDomain} target="_blank" rel="noopener noreferrer">{item.store_id.name}({item.store_id.presidentName})</a>
                                    ) : (
                                      <a className={item.store_id.isDelApp ? "text-red" : ""} href={"https://" + item.baseDomain} target="_blank" rel="noopener noreferrer">{item.store_id.name}({item.store_id.presidentName})</a>
                                    )}
                                    {item.inAppOrder_id ? (<>{' '}<GetOrderType orderType={item.inAppOrder_id.payType}/></>) : ''}
                                  </div>
                                  <div style={{color: '#a0aec0'}}>
                                    {item.store_id.domain ? (
                                      <a style={{color: '#a0aec0'}} href={"https://" + item.store_id.domain} target="_blank" rel="noopener noreferrer">{item.store_id.platformId}</a>
                                    ) : (
                                      <a style={{color: '#a0aec0'}} href={"https://" + item.store_id.platformId + ".cafe24.com"} target="_blank" rel="noopener noreferrer">{item.store_id.platformId}</a>
                                    )}
                                    {item.store_id.tel ? ' / ' + item.store_id.tel : ''}
                                    {(item.store_id.notificationEmail || item.store_id.email) ? ' / ' + (item.store_id.notificationEmail || item.store_id.email) : ''}
                                  </div>
                                </td>
                            ) : (
                                <td>샵 id : {item._id}</td>
                            )}
                            {/* 샵 */}
                            {item.store_id ? (
                                <td>
                                  <a className={item.store_id.isDelApp ? "text-red" : ""} href={"https://" + (item.primaryDomain ? item.primaryDomain : item.baseDomain)} target="_blank" rel="noopener noreferrer">{item.shopName} ({item.platformShopNo})</a>
                                  <div style={{fontSize: '10px', marginTop: '2px'}}>리뷰 부스터: {(item.entitlements && item.entitlements.reviewWriteAddon) ? <span style={{color: '#28a745', fontWeight: 700}}>부여</span> : <span style={{color: '#adb5bd'}}>미부여</span>}</div>
                                </td>
                            ) : (
                                <td>
                                  <a href={"https://" + (item.primaryDomain ? item.primaryDomain : item.baseDomain)} target="_blank" rel="noopener noreferrer">{item.shopName} ({item.platformShopNo})</a>
                                  <div style={{fontSize: '10px', marginTop: '2px'}}>리뷰 부스터: {(item.entitlements && item.entitlements.reviewWriteAddon) ? <span style={{color: '#28a745', fontWeight: 700}}>부여</span> : <span style={{color: '#adb5bd'}}>미부여</span>}</div>
                                </td>
                            )}
                            {this.storageCfg.etcType === "fn" ? (<>
                              {item.inAppOrder_id ? (<>
                                {/* 주문일 */}
                                <td>{moment(item.orderUpdatedAt).format('YYYY.MM.DD')}</td>
                                {/* 주문상세 / 사용기간 */}
                                <td>
                                  <div>{new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(item.inAppOrder_id.orderAmount)}</div>
                                  {item.inAppOrder_id.payType === "autoPayment" || item.inAppOrder_id.payType === "regular" ? null : (
                                    <div style={{fontSize: '11px', color: '#718096', marginTop: '2px'}}>
                                      <GetThisMonthPayDday targetDate={item.inAppOrder_id.endDate} payType={item.inAppOrder_id.payType}/>
                                    </div>
                                  )}
                                </td>
                                {/* 샵 주문수 */}
                                <td className="text-center">
                                  {item.periodOrderCount && item.periodOrderCount.orderCount !== null ? (() => {
                                    const months = item.periodOrderCount.start_date && item.periodOrderCount.end_date
                                      ? Math.max(Math.round(moment(item.periodOrderCount.end_date).diff(moment(item.periodOrderCount.start_date), 'days') / 30), 1) : 1;
                                    const avg = Math.round(item.periodOrderCount.orderCount / months);
                                    return (<>
                                      <div style={{fontWeight: '600'}}>{avg.toLocaleString()}</div>
                                      <div style={{fontSize: '10px', color: '#a0aec0'}}>월평균({months}개월)</div>
                                    </>);
                                  })() : '-'}
                                </td>
                                {/* 최근 인앱주문 (결제일 기준) */}
                                <td style={{fontSize: '11px'}}>
                                  {item.lastPaymentData && item.lastPaymentData.length > 0 ? (() => {
                                    const getDate = (p) => p.pay_date || p.payment_date || p.paid_date || p.approval_date || p.order_date || p.created_date || '';
                                    const autoPayments = item.lastPaymentData.filter(p => p.automatic_payment === 'T');
                                    const sorted = (autoPayments.length > 0 ? autoPayments : item.lastPaymentData)
                                      .slice().sort((a, b) => getDate(b).localeCompare(getDate(a)));
                                    const recent = sorted[0];
                                    const amt = recent.payment_amount || recent.paid_amount || recent.amount || 0;
                                    const dt = getDate(recent);
                                    return (<>
                                      {dt ? <div style={{fontWeight: '500'}}>{moment(dt).format('YY.MM.DD')}</div> : null}
                                      {amt ? <div style={{color: '#718096'}}>{new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(amt)}원</div> : null}
                                    </>);
                                  })() : '-'}
                                </td>
                              </>) : (<>
                                <td></td>
                                <td></td>
                                <td className="text-center">
                                  {item.periodOrderCount && item.periodOrderCount.orderCount !== null ? (() => {
                                    const months = item.periodOrderCount.start_date && item.periodOrderCount.end_date
                                      ? Math.max(Math.round(moment(item.periodOrderCount.end_date).diff(moment(item.periodOrderCount.start_date), 'days') / 30), 1) : 1;
                                    const avg = Math.round(item.periodOrderCount.orderCount / months);
                                    return (<>
                                      <div style={{fontWeight: '600'}}>{avg.toLocaleString()}</div>
                                      <div style={{fontSize: '10px', color: '#a0aec0'}}>월평균({months}개월)</div>
                                    </>);
                                  })() : '-'}
                                </td>
                                <td style={{fontSize: '11px'}}>-</td>
                                <td></td>
                              </>)}
                              {/* 이번달 결제 (최근 결제일 바로 오른쪽) */}
                              {this.renderThisMonthPayTd(item)}
                              {/* 주문정보 */}
                              <td className="text-center">
                                <ButtonGroup>
                                  <Button onClick={e => this.getOrderFormPlatform(item)}>주문정보</Button>
                                </ButtonGroup>
                              </td>
                              {/* 이미지 도메인변경 */}
                              <td className="text-center">
                                <ButtonGroup>
                                  <Button onClick={e => this.adminImgDomainUpdate(item, "review")}>리뷰</Button>
                                  <Button onClick={e => this.adminImgDomainUpdate(item, "product")}>상품</Button>
                                </ButtonGroup>
                              </td>
                              {/* 이미지 썸네일 */}
                              <td className="text-center">
                                <ButtonGroup>
                                  <Button onClick={e => this.genThumbImg(item)}>생성</Button>
                                </ButtonGroup>
                              </td>
                            </>) : this.storageCfg.etcType === "read" ? (<>
                              {/* 활성 스킨수 (항상 표시) */}
                              <td>{item.vr_skin ? item.vr_skin.length : 0}</td>
                              {item.inAppOrder_id ? (<>
                                {/* 주문일 */}
                                <td>{moment(item.orderUpdatedAt).format('YYYY.MM.DD')}</td>
                                {/* 주문상세 / 사용기간 */}
                                <td>
                                  <div>{new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(item.inAppOrder_id.orderAmount)}</div>
                                  {item.inAppOrder_id.payType === "autoPayment" || item.inAppOrder_id.payType === "regular" ? null : (
                                    <div style={{fontSize: '11px', color: '#718096', marginTop: '2px'}}>
                                      <GetThisMonthPayDday targetDate={item.inAppOrder_id.endDate} payType={item.inAppOrder_id.payType}/>
                                    </div>
                                  )}
                                </td>
                                {/* 샵 주문수 */}
                                <td className="text-center">
                                  {item.periodOrderCount && item.periodOrderCount.orderCount !== null ? (() => {
                                    const months = item.periodOrderCount.start_date && item.periodOrderCount.end_date
                                      ? Math.max(Math.round(moment(item.periodOrderCount.end_date).diff(moment(item.periodOrderCount.start_date), 'days') / 30), 1) : 1;
                                    const avg = Math.round(item.periodOrderCount.orderCount / months);
                                    return (<>
                                      <div style={{fontWeight: '600'}}>{avg.toLocaleString()}</div>
                                      <div style={{fontSize: '10px', color: '#a0aec0'}}>{item.periodOrderCount.start_date ? moment(item.periodOrderCount.start_date).format('MM.DD') + '~' + moment(item.periodOrderCount.end_date).format('MM.DD') : ''}</div>
                                    </>);
                                  })() : '-'}
                                </td>
                                {/* 최근 인앱주문 (결제일 기준) */}
                                <td style={{fontSize: '11px'}}>
                                  {item.lastPaymentData && item.lastPaymentData.length > 0 ? (() => {
                                    const getDate = (p) => p.pay_date || p.payment_date || p.paid_date || p.approval_date || p.order_date || p.created_date || '';
                                    const autoPayments = item.lastPaymentData.filter(p => p.automatic_payment === 'T');
                                    const sorted = (autoPayments.length > 0 ? autoPayments : item.lastPaymentData)
                                      .slice().sort((a, b) => getDate(b).localeCompare(getDate(a)));
                                    const recent = sorted[0];
                                    const amt = recent.payment_amount || recent.paid_amount || recent.amount || 0;
                                    const dt = getDate(recent);
                                    return (<>
                                      {dt ? <div style={{fontWeight: '500'}}>{moment(dt).format('YY.MM.DD')}</div> : null}
                                      {amt ? <div style={{color: '#718096'}}>{new Intl.NumberFormat('ko-KR', {currency: 'KRW'}).format(amt)}원</div> : null}
                                    </>);
                                  })() : '-'}
                                </td>
                              </>) : (<>
                                {/* inAppOrder_id 없는 경우: 컬럼 정렬 유지를 위해 빈 셀 4개 */}
                                <td className="text-center" style={{color: '#cbd5e0'}}>-</td>
                                <td className="text-center" style={{color: '#cbd5e0'}}>-</td>
                                <td className="text-center" style={{color: '#cbd5e0'}}>-</td>
                                <td className="text-center" style={{color: '#cbd5e0'}}>-</td>
                              </>)}
                              {/* 이번달 결제 (최근 결제일 바로 오른쪽) */}
                              {this.renderThisMonthPayTd(item)}
                            </>) : null}
                            {/* 기능 버튼 또는 메모 입력 */}
                            <td>
                              {this.storageCfg.etcType === "fn" ? (
                                  <>
                                    <ButtonGroup>
                                      <Button onClick={e => this.csLogin(item)}>login</Button>
                                      <Button onClick={e => this.modalToggle('isStoreDetail', item)}>상세</Button>
                                    </ButtonGroup>
                                  </>
                              ) : this.storageCfg.etcType === "read" ? (
                                  <>
                                    <div style={{display: 'flex', gap: '4px', alignItems: 'center', justifyContent: 'flex-end', whiteSpace: 'nowrap'}}>
                                      <Dropdown open={!!this.notifyDropdowns[item._id]} toggle={() => this.notifyDropdownToggle(item._id)} group>
                                        <DropdownToggle caret>알림</DropdownToggle>
                                        <DropdownMenu>
                                          <DropdownItem onClick={() => this.openNotifyModal(item, 'noPaied')}>미결제 알림</DropdownItem>
                                          <DropdownItem onClick={() => this.openNotifyModal(item, 'noPeriod')}>기간 알림</DropdownItem>
                                          <DropdownItem onClick={() => this.openNotifyModal(item, 'event')}>이벤트 알림</DropdownItem>
                                          <DropdownItem onClick={() => this.openNotifyModal(item, 'planUpgrade')}>업그레이드 알림</DropdownItem>
                                          <DropdownItem onClick={() => this.openNotifyModal(item, 'planDowngrade')}>다운그레이드 알림</DropdownItem>
                                        </DropdownMenu>
                                      </Dropdown>
                                      <ButtonGroup>
                                        <Button onClick={e => this.csLogin(item)}>login</Button>
                                        <Button onClick={e => this.modalToggle('isStoreDetail', item)}>상세</Button>
                                      </ButtonGroup>
                                    </div>
                                  </>
                              ) : (
                                  <InputGroup>
                                    <FormInput name="memo" placeholder="메모" onChange={event => {
                                      this.onChangeMemoValue(event, item.store_id)
                                    }} value={item.store_id.memo} className="table-input-text"/>
                                    <InputGroupAddon type="append"><Button theme="secondary" onClick={e => {
                                      this.updateStoreMemo(item.store_id)
                                    }}><i className="material-icons">업데이트</i></Button><Button onClick={e => this.csLogin(item)}>login</Button><Button onClick={e => this.modalToggle('isStoreDetail', item)}>상세</Button></InputGroupAddon>
                                  </InputGroup>
                              )}
                            </td>
                          </tr>
                        );
                      })
                      :
                      <tr>
                        <td colSpan={9} className="text-center">가입한 스토어가 없습니다</td>
                      </tr>
                  }

                  </tbody>
                </table>
                </>
                )}
                <PaginationInPage />
              </div>
            </form>
          </div>
        </div>

        <Modal size="md" open={this.modals.isImgDomainConfirm} toggle={() => { this.modals.isImgDomainConfirm = false; }} centered={true}>
          <ModalHeader>이미지 도메인 변경 확인</ModalHeader>
          <ModalBody>
            {this.modals.imgDomainConfirmData && (
              <div>
                <p style={{marginBottom: 12}}>아래 도메인으로 저장된 이미지 URL을 치환합니다. 필요시 수정 후 실행하세요.</p>
                <table className="table table-sm" style={{fontSize: '13px'}}>
                  <tbody>
                    <tr><th style={{width: '30%'}}>대상</th><td>{this.modals.imgDomainConfirmData.type === 'review' ? '리뷰 이미지' : '상품 이미지'}</td></tr>
                    <tr><th>스토어</th><td>{this.modals.imgDomainConfirmData.storeName || '-'}</td></tr>
                    <tr><th>Shop</th><td>#{this.modals.imgDomainConfirmData.shopNo} {this.modals.imgDomainConfirmData.shopName ? `(${this.modals.imgDomainConfirmData.shopName})` : ''}</td></tr>
                    <tr>
                      <th>변경 전 도메인</th>
                      <td>
                        <FormInput
                          value={this.modals.imgDomainConfirmData.primaryDomain || ''}
                          onChange={e => { this.modals.imgDomainConfirmData.primaryDomain = e.target.value; }}
                          placeholder="예: shop.example.com"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>변경 후 도메인</th>
                      <td>
                        <FormInput
                          value={this.modals.imgDomainConfirmData.baseDomain || ''}
                          onChange={e => { this.modals.imgDomainConfirmData.baseDomain = e.target.value; }}
                          placeholder="예: example.cafe24.com"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p style={{color: '#6c757d', fontSize: '12px', marginTop: 8}}>
                  ※ "변경 전 도메인" 문자열이 포함된 이미지 URL을 "변경 후 도메인"으로 일괄 치환합니다.
                </p>
              </div>
            )}
            <div className="text-center mt-3">
              <ButtonGroup>
                <Button theme="primary" disabled={this.isImgDomainRunning} onClick={() => this.runImgDomainUpdate()}>
                  {this.isImgDomainRunning ? '실행 중...' : '실행하기'}
                </Button>
                <Button theme="light" disabled={this.isImgDomainRunning} onClick={() => { this.modals.isImgDomainConfirm = false; }}>취소</Button>
              </ButtonGroup>
            </div>
          </ModalBody>
        </Modal>

        <Modal size="lg" className='modal-review-write-form' open={this.modals.isStoreDetail} toggle={() => this.modals.isStoreDetail = false} centered={true}>
          <ModalHeader toggle={() => this.modals.isStoreDetail = false}>스토어 상세 보기</ModalHeader>
          <ModalBody className="history-window-popup">
            <div className="history-popup-contents">
              {this.modals.storeDetailData.store_id ? (
                  <table>
                    <colgroup>
                      <col style={{width: '15%'}}/>
                      <col style={{width: '35%'}}/>
                      <col style={{width: '15%'}}/>
                      <col style={{width: '35%'}}/>
                    </colgroup>
                    <tbody>
                    <tr>
                      <th>쇼핑몰</th>
                      <td>{this.modals.storeDetailData.store_id.name}({this.modals.storeDetailData.store_id.presidentName})
                        / {this.modals.storeDetailData.store_id.domain ? (
                            <a href={"https://" + this.modals.storeDetailData.store_id.domain}
                               target="_blank" rel="noopener noreferrer">{this.modals.storeDetailData.store_id.domain}</a>
                        ) : (
                            <a href={"https://" + this.modals.storeDetailData.store_id.platformId + ".cafe24.com"}
                               target="_blank" rel="noopener noreferrer">{this.modals.storeDetailData.store_id.platformId + ".cafe24.com"}</a>
                        )} / {this.modals.storeDetailData.store_id.platformId}</td>
                      <th>평균 주문수</th>
                      <td>{Math.ceil((Number(this.modals.storeDetailData.detail && this.modals.storeDetailData.detail.getMonthlySales) || 0) / 3)}</td>
                    </tr>
                    <tr>
                      <th>주문수 시작일</th>
                      <td>{this.modals.storeDetailData.detail ? this.modals.storeDetailData.detail.getMonthlySalesStartDate : ''}</td>
                      <th>주문수 종료일</th>
                      <td>{this.modals.storeDetailData.detail ? this.modals.storeDetailData.detail.getMonthlySalesEndDate : ''}</td>
                    </tr>
                    <tr>
                      <th>최근 구독 항목</th>
                      <td colSpan="3">
                        {(() => {
                          const orderStatus = this.modals.storeDetailData.detail && this.modals.storeDetailData.detail.orderStatus;
                          const latest = getLatestSubscriptionItem(orderStatus);
                          if (!latest) return <span className="text-muted">-</span>;
                          return (
                            <div>
                              <Badge theme="info" className="mr-2">구독</Badge>
                              <strong>마지막 결제일: {moment(latest.pay_date).format('YYYY.MM.DD HH:mm')}</strong>
                              {latest.order_id && <span className="ml-2 text-muted">/ 주문번호: {latest.order_id}</span>}
                              {latest.amount !== undefined && latest.amount !== null && (
                                <span className="ml-2">/ 금액: {Number(latest.amount).toLocaleString()}원</span>
                              )}
                            </div>
                          );
                        })()}
                      </td>
                    </tr>
                    <tr>
                      <th>구독 결제내용</th>
                      <td colSpan="3">
                        {(() => {
                          const list = (this.modals.storeDetailData.detail && this.modals.storeDetailData.detail.orderStatus) || [];
                          const subs = list.filter(p => p.automatic_payment === 'T');
                          if (subs.length === 0) return <span className="text-muted">구독 결제 내역이 없습니다.</span>;
                          return (
                            <ul>
                              {subs.map((item, i) => (
                                <li key={`sub-${i}`}><PaymentItem paymentItem={item}/></li>
                              ))}
                            </ul>
                          );
                        })()}
                      </td>
                    </tr>
                    <tr>
                      <th>선결제 결제내용</th>
                      <td colSpan="3">
                        {(() => {
                          const list = (this.modals.storeDetailData.detail && this.modals.storeDetailData.detail.orderStatus) || [];
                          const onepays = list.filter(p => p.automatic_payment !== 'T');
                          if (onepays.length === 0) return <span className="text-muted">선결제 내역이 없습니다.</span>;
                          return (
                            <ul>
                              {onepays.map((item, i) => (
                                <li key={`one-${i}`}><PaymentItem paymentItem={item}/></li>
                              ))}
                            </ul>
                          );
                        })()}
                      </td>
                    </tr>
                    <tr>
                      <th>이번달 결제여부</th>
                      <td colSpan="3">
                        <FormCheckbox
                          checked={!!(this.modals.storeDetailData.isPaymentThisMonth !== undefined
                            ? this.modals.storeDetailData.isPaymentThisMonth
                            : (this.modals.storeDetailData.detail && isThisMonthSubscriptionPaid(this.modals.storeDetailData.detail.orderStatus)))}
                          onChange={() => {
                            const currentStatus = this.modals.storeDetailData.isPaymentThisMonth !== undefined
                              ? this.modals.storeDetailData.isPaymentThisMonth
                              : (this.modals.storeDetailData.detail && isThisMonthSubscriptionPaid(this.modals.storeDetailData.detail.orderStatus));
                            this.updateShopPaymentStatus(this.modals.storeDetailData, !currentStatus);
                          }}
                          style={{display: 'inline-block'}}
                        >
                          {(this.modals.storeDetailData.isPaymentThisMonth !== undefined
                            ? this.modals.storeDetailData.isPaymentThisMonth
                            : (this.modals.storeDetailData.detail && isThisMonthSubscriptionPaid(this.modals.storeDetailData.detail.orderStatus))) ? (
                            <Badge theme="success">결제 완료 ({moment().format('YYYY년 MM월')})</Badge>
                          ) : (
                            <Badge theme="warning">미결제 ({moment().format('YYYY년 MM월')})</Badge>
                          )}
                        </FormCheckbox>
                      </td>
                    </tr>
                    <tr>
                      <th>리뷰 부스터 권한</th>
                      <td colSpan="3">
                        {(() => {
                          const ent = (this.modals.storeDetailData && this.modals.storeDetailData.entitlements) || {};
                          const hasAddon = !!ent.reviewWriteAddon;
                          return (
                            <span onClick={(e) => e.stopPropagation()} style={{display: 'inline-flex', alignItems: 'center', gap: 10}}>
                              <FormCheckbox
                                toggle
                                checked={hasAddon}
                                onChange={() => this.toggleShopReviewWriteAddon(!hasAddon)}
                                style={{display: 'inline-block', marginBottom: 0}}
                              >
                                {hasAddon
                                  ? <Badge theme="success">부여됨</Badge>
                                  : <Badge theme="secondary">미부여</Badge>}
                              </FormCheckbox>
                              <span style={{fontSize: 12, color: '#94A3B8'}}>리뷰작성 · 대량등록 · 복사 · 그룹 관리도구 사용 권한</span>
                            </span>
                          );
                        })()}
                      </td>
                    </tr>
                    <tr>
                      <th>리뷰 수</th>
                      <td>{this.modals.storeDetailData.detail ? this.modals.storeDetailData.detail.reviewCount : 0}
                        <Button className="ml-2" theme="danger"
                                onClick={event => this.delAllReview(this.modals.storeDetailData)}>전체삭제</Button></td>
                      <th>상품 수</th>
                      <td>{this.modals.storeDetailData.detail ? this.modals.storeDetailData.detail.productCount : 0}</td>
                    </tr>
                    <tr>
                      <th>회원탈퇴</th>
                      <td><Button className="ml-2" theme="danger"
                                  onClick={event => this.withdrawal(this.modals.storeDetailData)}>회원탈퇴</Button></td>
                      <th>구독취소</th>
                      <td>
                        <FormSelect name="shopNo"
                                    onChange={event => {
                                      this.onChangeModalInputs(event, this.modals.storeDetailData.store_id)
                                    }}>
                          <option value="">-</option>
                          {
                            this.modals && this.modals.shop ? this.modals.shop.map((item, i) => (
                                <option key={i} value={item.platformShopNo}>{item.platformShopNo}-{item.shopName}</option>
                            )) : null
                          }
                        </FormSelect>
                        <Button className="ml-2" theme="danger"
                                onClick={event => this.unsubscribeUser(this.modals.storeDetailData.store_id)}>구독취소</Button>
                      </td>
                    </tr>
                    <tr>
                      <th>id</th>
                      <td>{this.modals.storeDetailData.store_id._id}</td>
                      <th>결제 id</th>
                      <td>{this.modals.storeDetailData._id}</td>
                    </tr>
                    <tr>
                      <th>cafe24Tokens</th>
                      <td colSpan={3}>
                        {this.modals.storeDetailData.cafe24Tokens && this.modals.storeDetailData.cafe24Tokens.length > 0 ?
                            (<ul>
                              {
                                this.modals.storeDetailData.cafe24Tokens.map((item, i) => (
                                    <li key={i}>{moment(item.refresh_token_expires_at).format("MM-DD")} {' // scopes : '} {item.scopes ? item.scopes.length : ""}</li>
                                ))
                              }
                            </ul>) : null}
                      </td>
                    </tr>
                    <tr>
                      <th>빠른 기능</th>
                      <td colSpan={3}>
                        <ButtonGroup>
                          <Button theme="warning" onClick={event => this.openNotifyModal(this.modals.storeDetailData, 'noPaied')}>미결제 알림</Button>
                          <Button theme="info" onClick={event => this.openNotifyModal(this.modals.storeDetailData, 'noPeriod')}>기간 알림</Button>
                          <Button theme="success" onClick={event => this.openNotifyModal(this.modals.storeDetailData, 'planUpgrade')}>업그레이드 알림</Button>
                          <Button theme="warning" onClick={event => this.openNotifyModal(this.modals.storeDetailData, 'planDowngrade')}>다운그레이드 알림</Button>
                          <Button theme="primary" onClick={event => this.csLogin(this.modals.storeDetailData)}>로그인</Button>
                        </ButtonGroup>
                      </td>
                    </tr>
                    </tbody>
                  </table>) : null}

              <div className="text-center mt-2">
                {/*<Button onClick={event => this.updateReview(this.modals.data)} >리뷰작성</Button>*/}
                <Button className="ml-2" theme="light" onClick={event => this.modals.isStoreDetail = false}>닫기</Button>
              </div>
            </div>

          </ModalBody>
        </Modal>
        <ModalLoading isLoading={this.isLoading}/>
        <NotificationSendModal isOpen={this.notifyModal.isOpen} params={this.notifyModal.params} onClose={this.closeNotifyModal}/>
        <MailTemplateModal isOpen={this.mailTplOpen} onClose={this.closeMailTpl}/>
        <SmsTemplateModal isOpen={this.smsTplOpen} onClose={this.closeSmsTpl}/>
      </div>
    )
  }
}

export default ShopList;
